import { render } from "./SaidaM.vue?vue&type=template&id=4beda2cf&scoped=true"
import script from "./SaidaM.vue?vue&type=script&lang=js"
export * from "./SaidaM.vue?vue&type=script&lang=js"

import "./SaidaM.vue?vue&type=style&index=0&id=4beda2cf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4beda2cf"]])

export default __exports__